import { ChildMsg_ofMsg, DefaultActions_create, DefaultActions_Types_UpdateArgs$3, DefaultActions_runUpdate, DefaultActions_Types_ChildModel$2, Child$1, ChildAbsentStrategy$1, Child_absentChildCheck } from "../Common/Terminate.js";
import { FileComponentSpecs, MaximumFiles, FileType_get_all } from "../FileManagement/Shared.js";
import { value as value_4, some, map, defaultArg } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { update as update_2, init as init_1 } from "../FileManagement/FileUploadSelectors/DragDropFileSelector/DragDropState.js";
import { Msg, Model, MediaFilter as MediaFilter_1, ViewMode as ViewMode_1 } from "./MediaTypes.js";
import { MediaViewModel_toDomain_Z7357511, MediaViewModel, MediaViewModel_get_empty } from "../ThreeDocs.Models/View/MediaViewModel.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";
import { ListDisplayModification_ListDisplayModification$2, Sort_SortInfo$1, Sort_SortDirection, Sort_SortableColumn$1, Sort_Compare$1 } from "../ThreeDocs.SharedUI/Sort.js";
import { length, ofArray, map as map_1, cons, tryHead, filter, singleton as singleton_1, empty } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { Cmd_none, Cmd_map, Cmd_batch } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { exists, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.25.0/Seq.js";
import { Result_map, Result_mapError, Result_bind, ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__ReturnFrom_1505, ResultComputationExpression_ResultBuilder__Delay_1505, ResultComputationExpression_ResultBuilder__Run_FCFD9EF } from "../fable_modules/AsyncResult.0.3.0/Result.fs.js";
import { InboundMsg as InboundMsg_1, Model_getNumberOfAssociatedFiles_Z23C80908, FileManagementUpdateArgs, Model_tryTerminate_Z23C80908 } from "../FileManagement/FileManagementTypes.js";
import { toList as toList_1, isEmpty } from "../fable_modules/fable-library-js.4.25.0/Map.js";
import { FileOperationContext, ErrorMessage, ErrorMessage_get_describe } from "../ThreeDocs.Models/Api/Api.js";
import { FormValidationError_get_describe, FormValidationError } from "../ThreeDocs.SharedUI/FormValidation.js";
import { newGuid } from "../fable_modules/fable-library-js.4.25.0/Guid.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { securedApi } from "../Api.js";
import { error } from "../ThreeDocs.SharedUI/Toast.js";
import { equals } from "../fable_modules/fable-library-js.4.25.0/Util.js";
import { split, printf, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { InOut_wrapInboundMsg } from "../Common/Common.js";
import { DragDropFileSelectorUpdateArgs, InboundMsg } from "../FileManagement/FileUploadSelectors/DragDropFileSelector/DragDropTypes.js";
import { MediaType_tryParseFromExtension_Z721C83C5 } from "../ThreeDocs.Models/Domain/MediaType.js";
import { last } from "../fable_modules/fable-library-js.4.25.0/Array.js";
import { init as init_2, update as update_1 } from "../FileManagement/FileManagementState.js";
import { S3Context } from "../Common/AwsCommon.js";
import { Terminate_TerminateError_get_describe } from "../ThreeDocs.Models/Shared.js";

export const dragDropChildAbsentStrategy = new ChildAbsentStrategy$1(0, [(model) => Child_absentChildCheck(model.dragDropFileManagementModel.child)]);

export function dragDropFileSpecs(maybePracticeId) {
    return new FileComponentSpecs(FileType_get_all(), defaultArg(map((practiceId) => (`${practiceId}/`), maybePracticeId), "3docsGeneralMedia/"), new MaximumFiles(1, [1]));
}

export function init(maybePracticeId, currentRoles) {
    const patternInput = init_1(dragDropFileSpecs(maybePracticeId));
    return [new Model(new ViewMode_1(0, []), new MediaFilter_1(2, []), MediaViewModel_get_empty(), new FSharpResult$2(0, [undefined]), new Sort_SortInfo$1(new Sort_SortableColumn$1("", (_arg) => "", new Sort_Compare$1((_arg_1, _arg_2) => 0)), new Sort_SortDirection(1, [])), currentRoles, empty(), empty(), new DefaultActions_Types_ChildModel$2(new Child$1(1, []), dragDropChildAbsentStrategy, "DragDrop File Management component"), patternInput[0]), Cmd_batch(toList(delay(() => append(singleton(Cmd_map((Item_1) => (new Msg(22, [Item_1])), patternInput[1])), delay(() => {
        let msg;
        const matchValue = maybePracticeId;
        return (matchValue == null) ? singleton(Cmd_none()) : singleton((msg = (new Msg(15, [matchValue])), singleton_1((dispatch) => {
            dispatch(msg);
        })));
    })))))];
}

export function tryTerminate(model) {
    return ResultComputationExpression_ResultBuilder__Run_FCFD9EF(ResultComputationExpression_result, ResultComputationExpression_ResultBuilder__Delay_1505(ResultComputationExpression_result, () => {
        let child;
        return ResultComputationExpression_ResultBuilder__ReturnFrom_1505(ResultComputationExpression_result, (child = model.dragDropFileManagementModel.child, (child.tag === 1) ? (new FSharpResult$2(0, [() => {
        }])) : ((child.tag === 2) ? (new FSharpResult$2(0, [() => {
        }])) : (Model_tryTerminate_Z23C80908)(child.fields[0]))));
    }));
}

export function update(args, userInfo, maybePracticeId, msg, model) {
    let bind$0040, bind$0040_2, matchValue_4, bind$0040_4, msg_15, msg_21, bind$0040_5, matchValue_8, arg_7, bind$0040_6, msg_31;
    let matchResult, setter, viewMode, mediaFilter, sortInfo, mediaVm, mediaVm_1, e, practiceId, media_2, media_3, e_1, pid, ex, fileName_1, msg_25, msg_27, selected;
    switch (msg.tag) {
        case 2: {
            matchResult = 1;
            setter = msg.fields[0];
            break;
        }
        case 3: {
            matchResult = 2;
            viewMode = msg.fields[0];
            break;
        }
        case 4: {
            matchResult = 3;
            mediaFilter = msg.fields[0];
            break;
        }
        case 5: {
            matchResult = 4;
            sortInfo = msg.fields[0];
            break;
        }
        case 6: {
            matchResult = 5;
            break;
        }
        case 7: {
            matchResult = 6;
            break;
        }
        case 8: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 7;
                mediaVm = msg.fields[0].fields[0];
            }
            break;
        }
        case 10: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 8;
                mediaVm_1 = msg.fields[0].fields[0];
            }
            break;
        }
        case 9: {
            matchResult = 9;
            break;
        }
        case 11: {
            matchResult = 10;
            break;
        }
        case 12: {
            if (msg.fields[0].tag === 1) {
                matchResult = 12;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 11;
            }
            break;
        }
        case 15: {
            matchResult = 13;
            practiceId = msg.fields[0];
            break;
        }
        case 13: {
            matchResult = 14;
            break;
        }
        case 16: {
            if (msg.fields[0].tag === 1) {
                matchResult = 17;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 15;
                media_2 = msg.fields[0].fields[0];
            }
            break;
        }
        case 14: {
            if (msg.fields[0].tag === 1) {
                matchResult = 17;
                e_1 = msg.fields[0].fields[0];
            }
            else {
                matchResult = 16;
                media_3 = msg.fields[0].fields[0];
            }
            break;
        }
        case 17: {
            switch (msg.fields[0].tag) {
                case 4: {
                    matchResult = 18;
                    pid = msg.fields[0].fields[0];
                    break;
                }
                case 5: {
                    matchResult = 19;
                    break;
                }
                default:
                    matchResult = 20;
            }
            break;
        }
        case 0: {
            matchResult = 21;
            ex = msg.fields[0];
            break;
        }
        case 20: {
            matchResult = 22;
            break;
        }
        case 21: {
            if (msg.fields[0].chainedMsg.tag === 1) {
                if (msg.fields[0].chainedMsg.fields[0].tag === 3) {
                    if (args.MaybeS3Context != null) {
                        matchResult = 23;
                        fileName_1 = msg.fields[0].chainedMsg.fields[0].fields[0];
                    }
                    else {
                        matchResult = 24;
                        msg_25 = msg.fields[0];
                    }
                }
                else {
                    matchResult = 24;
                    msg_25 = msg.fields[0];
                }
            }
            else {
                matchResult = 24;
                msg_25 = msg.fields[0];
            }
            break;
        }
        case 19: {
            matchResult = 25;
            break;
        }
        case 18: {
            matchResult = 26;
            break;
        }
        case 22: {
            if (msg.fields[0].tag === 1) {
                matchResult = 28;
                selected = msg.fields[0].fields[0].fields[0];
            }
            else {
                matchResult = 27;
                msg_27 = msg.fields[0].fields[0];
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, userInfo.roles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), defaultArg(map((arg) => singleton_1((dispatch) => {
                dispatch(new Msg(15, [arg]));
            }), maybePracticeId), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(13, []));
            }))];
        case 1:
            return [new Model(model.ViewMode, model.MediaFilter, setter(model.SelectedMedia), model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(6, []));
            })];
        case 2:
            switch (viewMode.tag) {
                case 4:
                case 0:
                    return [new Model(viewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_4) => {
                        dispatch_4(new Msg(19, []));
                    })];
                case 1:
                    return [new Model(viewMode, model.MediaFilter, viewMode.fields[0], model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_5) => {
                        dispatch_5(new Msg(19, []));
                    })];
                case 3:
                    return [new Model(viewMode, model.MediaFilter, viewMode.fields[0], model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_6) => {
                        dispatch_6(new Msg(18, []));
                    })];
                default:
                    return [new Model(viewMode, model.MediaFilter, (bind$0040 = MediaViewModel_get_empty(), new MediaViewModel(bind$0040.mediaId, maybePracticeId, bind$0040.name, bind$0040.description, bind$0040.s3Key, bind$0040.s3Url, bind$0040.specialty, bind$0040.procedure, bind$0040.language, bind$0040.mediaType)), model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_3) => {
                        dispatch_3(new Msg(18, []));
                    })];
            }
        case 3: {
            const _listModification = new ListDisplayModification_ListDisplayModification$2("MediaFilter", 1, (itemList) => filter((item) => {
                switch (mediaFilter.tag) {
                    case 1:
                        return item.practiceId != null;
                    case 2:
                        return true;
                    default:
                        return item.practiceId == null;
                }
            }, itemList));
            return [new Model(model.ViewMode, mediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), Cmd_none()];
        }
        case 4:
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, sortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), Cmd_none()];
        case 5:
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, Result_bind()(() => {
                const matchValue_3 = model.dragDropFileManagementModel.child;
                return (matchValue_3.tag === 0) ? (isEmpty(matchValue_3.fields[0].DownloadableFiles) ? (new FSharpResult$2(1, [ErrorMessage_get_describe()(new ErrorMessage(4, [new FormValidationError(0, ["A Media File", "be uploaded"])]))])) : (new FSharpResult$2(0, [undefined]))) : (new FSharpResult$2(0, [undefined]));
            })(Result_mapError()((_arg) => ((_arg.tag === 1) ? ((_arg.fields[0] === "S3 Key") ? "A Media File must be uploaded" : FormValidationError_get_describe()(_arg)) : ((_arg.tag === 2) ? ((_arg.fields[0] === "S3 Key") ? "A Media File must be uploaded" : FormValidationError_get_describe()(_arg)) : FormValidationError_get_describe()(_arg))))(Result_map()((value_1) => {
            })(MediaViewModel_toDomain_Z7357511((bind$0040_2 = model.SelectedMedia, new MediaViewModel(newGuid(), bind$0040_2.practiceId, bind$0040_2.name, bind$0040_2.description, bind$0040_2.s3Key, bind$0040_2.s3Url, bind$0040_2.specialty, bind$0040_2.procedure, bind$0040_2.language, bind$0040_2.mediaType)))))), model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), Cmd_none()];
        case 6: {
            let updatedSelected;
            const bind$0040_3 = model.SelectedMedia;
            updatedSelected = (new MediaViewModel(bind$0040_3.mediaId, bind$0040_3.practiceId, bind$0040_3.name, bind$0040_3.description, (matchValue_4 = model.dragDropFileManagementModel.child, (matchValue_4.tag === 0) ? map((tuple) => tuple[0], tryHead(toList_1(matchValue_4.fields[0].DownloadableFiles))) : undefined), bind$0040_3.s3Url, bind$0040_3.specialty, bind$0040_3.procedure, bind$0040_3.language, bind$0040_3.mediaType));
            return [new Model(model.ViewMode, model.MediaFilter, updatedSelected, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, securedApi(args.Token).createMedia, updatedSelected, (Item_2) => (new Msg(8, [Item_2])), (Item_3) => (new Msg(0, [Item_3])))];
        }
        case 7:
            return [(mediaVm.practiceId == null) ? (new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, cons(mediaVm, model.PublicMedia), model.dragDropFileManagementModel, model.dragDropModel)) : (new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, cons(mediaVm, model.PracticeMedia), model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel)), singleton_1((dispatch_7) => {
                dispatch_7(new Msg(3, [new ViewMode_1(1, [mediaVm])]));
            })];
        case 8:
            return [(mediaVm_1.practiceId == null) ? (new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, map_1((media_1) => {
                if (media_1.mediaId === mediaVm_1.mediaId) {
                    return mediaVm_1;
                }
                else {
                    return media_1;
                }
            }, model.PublicMedia), model.dragDropFileManagementModel, model.dragDropModel)) : (new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, map_1((media) => {
                if (media.mediaId === mediaVm_1.mediaId) {
                    return mediaVm_1;
                }
                else {
                    return media;
                }
            }, model.PracticeMedia), model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel)), singleton_1((dispatch_8) => {
                dispatch_8(new Msg(3, [new ViewMode_1(1, [mediaVm_1])]));
            })];
        case 9: {
            let s3Key_1;
            const matchValue_7 = model.dragDropFileManagementModel.child;
            s3Key_1 = ((matchValue_7.tag === 0) ? map((tuple_1) => tuple_1[0], tryHead(toList_1(matchValue_7.fields[0].DownloadableFiles))) : undefined);
            return [model, Cmd_OfAsyncWith_either((x_1) => {
                AsyncHelpers_start(x_1);
            }, securedApi(args.Token).editMedia, (bind$0040_4 = model.SelectedMedia, new MediaViewModel(bind$0040_4.mediaId, bind$0040_4.practiceId, bind$0040_4.name, bind$0040_4.description, s3Key_1, bind$0040_4.s3Url, bind$0040_4.specialty, bind$0040_4.procedure, bind$0040_4.language, bind$0040_4.mediaType)), (Item_4) => (new Msg(10, [Item_4])), (Item_5) => (new Msg(0, [Item_5])))];
        }
        case 10:
            return [model, Cmd_OfAsyncWith_either((x_2) => {
                AsyncHelpers_start(x_2);
            }, securedApi(args.Token).deleteMedia, model.SelectedMedia.mediaId, (Item_6) => (new Msg(12, [Item_6])), (Item_7) => (new Msg(0, [Item_7])))];
        case 11:
            return [model, Cmd_batch(ofArray([singleton_1((dispatch_9) => {
                dispatch_9(new Msg(3, [new ViewMode_1(0, [])]));
            }), (msg_15 = defaultArg(map((Item_8) => (new Msg(15, [Item_8])), maybePracticeId), new Msg(13, [])), singleton_1((dispatch_10) => {
                dispatch_10(msg_15);
            }))]))];
        case 12:
            return [model, error(ErrorMessage_get_describe()(e))];
        case 13:
            return [model, Cmd_OfAsyncWith_either((x_3) => {
                AsyncHelpers_start(x_3);
            }, securedApi(args.Token).getAllMediaForPractice, practiceId, (Item_9) => (new Msg(16, [Item_9])), (Item_10) => (new Msg(0, [Item_10])))];
        case 14:
            return [model, Cmd_OfAsyncWith_either((x_4) => {
                AsyncHelpers_start(x_4);
            }, securedApi(args.Token).getAllPublicMedia, undefined, (Item_11) => (new Msg(14, [Item_11])), (Item_12) => (new Msg(0, [Item_12])))];
        case 15:
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, media_2, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_11) => {
                dispatch_11(new Msg(13, []));
            })];
        case 16:
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, media_3, model.dragDropFileManagementModel, model.dragDropModel), Cmd_none()];
        case 17:
            return [model, error(ErrorMessage_get_describe()(e_1))];
        case 18:
            return [model, equals(maybePracticeId, pid) ? singleton_1((dispatch_12) => {
                dispatch_12(new Msg(15, [pid]));
            }) : Cmd_none()];
        case 19:
            return [model, singleton_1((dispatch_13) => {
                dispatch_13(new Msg(13, []));
            })];
        case 20:
            return [model, Cmd_none()];
        case 21: {
            console.error(some(toText(printf("Error: %O"))(ex)));
            return [model, Cmd_none()];
        }
        case 22:
            return [model, (msg_21 = (new Msg(22, [InOut_wrapInboundMsg(new InboundMsg())])), singleton_1((dispatch_14) => {
                dispatch_14(msg_21);
            }))];
        case 23:
            return [new Model(model.ViewMode, model.MediaFilter, (bind$0040_5 = model.SelectedMedia, new MediaViewModel(bind$0040_5.mediaId, bind$0040_5.practiceId, bind$0040_5.name, bind$0040_5.description, fileName_1, `https://${value_4(args.MaybeS3Context).ActiveBucket}.s3.${value_4(args.MaybeS3Context).S3Config.Region}.amazonaws.com/`, bind$0040_5.specialty, bind$0040_5.procedure, bind$0040_5.language, MediaType_tryParseFromExtension_Z721C83C5((matchValue_8 = exists((y) => ("." === y), fileName_1.split("")), matchValue_8 ? last(split(fileName_1, ["."], undefined, 0)) : "")))), model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, model.dragDropModel), singleton_1((dispatch_15) => {
                dispatch_15(new Msg(20, []));
            })];
        case 24: {
            let patternInput_1;
            const patternInput = DefaultActions_runUpdate(new DefaultActions_Types_UpdateArgs$3((msg_1, model_1) => {
                let bind$0040_1;
                const matchValue = args.MaybeCredentials;
                const matchValue_1 = args.MaybeS3Context;
                let matchResult_1, context, credentials;
                if (matchValue != null) {
                    if (matchValue_1 != null) {
                        matchResult_1 = 0;
                        context = matchValue_1;
                        credentials = matchValue;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const args_1 = new FileManagementUpdateArgs(args.Token, credentials, context);
                        if (msg_1.tag === 1) {
                            return [model_1, Cmd_none()];
                        }
                        else {
                            return update_1(model.SelectedMedia.s3Key, new FileManagementUpdateArgs(args_1.Token, args_1.Credentials, (bind$0040_1 = args_1.Context, new S3Context(bind$0040_1.S3Config, bind$0040_1.S3Client, bind$0040_1.S3Expiry, args_1.Context.ActiveBucket))), msg_1.fields[0], model_1);
                        }
                    }
                    default:
                        return [model_1, error("Missing Credentials or S3 Context")];
                }
            }, model), model.dragDropFileManagementModel, msg_25);
            patternInput_1 = [patternInput[0], patternInput[1]];
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, patternInput_1[0], model.dragDropModel), Cmd_batch(ofArray([Cmd_map((Item_14) => (new Msg(21, [Item_14])), patternInput_1[1]), singleton_1((dispatch_16) => {
                dispatch_16(new Msg(6, []));
            })]))];
        }
        case 25: {
            const matchValue_9 = tryTerminate(model);
            if (matchValue_9.tag === 1) {
                return [model, error((arg_7 = Terminate_TerminateError_get_describe()(matchValue_9.fields[0]), toText(printf("Termination failed: %O"))(arg_7)))];
            }
            else {
                matchValue_9.fields[0]();
                return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, (bind$0040_6 = model.dragDropFileManagementModel, new DefaultActions_Types_ChildModel$2(new Child$1(2, []), bind$0040_6.childAbsentStrategy, bind$0040_6.childComponentName)), model.dragDropModel), Cmd_none()];
            }
        }
        case 26: {
            const fileOperationContext = defaultArg(map((practiceId_1) => (new FileOperationContext(0, [practiceId_1])), maybePracticeId), new FileOperationContext(1, []));
            const createdDragDropFileManagement = init_2(dragDropFileSpecs(maybePracticeId), fileOperationContext, model.SelectedMedia.s3Key);
            const patternInput_2 = DefaultActions_create(createdDragDropFileManagement[0], createdDragDropFileManagement[1], model.dragDropFileManagementModel);
            const patternInput_3 = init_1(dragDropFileSpecs(maybePracticeId));
            return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, patternInput_2[0], patternInput_3[0]), Cmd_batch(ofArray([Cmd_map((Item_15) => (new Msg(21, [Item_15])), patternInput_2[1]), Cmd_map((Item_16) => (new Msg(22, [Item_16])), patternInput_3[1])]))];
        }
        case 27: {
            const matchValue_10 = args.MaybeCredentials;
            const matchValue_11 = args.MaybeS3Context;
            let matchResult_2, context_1, credentials_1;
            if (matchValue_10 != null) {
                if (matchValue_11 != null) {
                    matchResult_2 = 0;
                    context_1 = matchValue_11;
                    credentials_1 = matchValue_10;
                }
                else {
                    matchResult_2 = 1;
                }
            }
            else {
                matchResult_2 = 1;
            }
            switch (matchResult_2) {
                case 0:
                    if (model.dragDropFileManagementModel.child.tag === 0) {
                        const fileManagementModel = model.dragDropFileManagementModel.child.fields[0];
                        const patternInput_4 = update_2(new DragDropFileSelectorUpdateArgs(args.Token, Model_getNumberOfAssociatedFiles_Z23C80908(fileManagementModel) + length(fileManagementModel.UploadSelection), credentials_1, context_1), msg_27, model.dragDropModel);
                        return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, patternInput_4[0]), Cmd_batch(ofArray([Cmd_map((Item_17) => (new Msg(22, [Item_17])), patternInput_4[1]), singleton_1((dispatch_17) => {
                            dispatch_17(new Msg(6, []));
                        })]))];
                    }
                    else {
                        console.debug("FileParentState::DragDropMsg while child is not active");
                        const patternInput_5 = update_2(new DragDropFileSelectorUpdateArgs(args.Token, 0, credentials_1, context_1), msg_27, model.dragDropModel);
                        return [new Model(model.ViewMode, model.MediaFilter, model.SelectedMedia, model.IsSelectedMediaValid, model.SortInfo, model.CurrentRoles, model.PracticeMedia, model.PublicMedia, model.dragDropFileManagementModel, patternInput_5[0]), Cmd_map((Item_18) => (new Msg(22, [Item_18])), patternInput_5[1])];
                    }
                default:
                    return [model, error("Missing Credentials or S3 Context")];
            }
        }
        default:
            return [model, (msg_31 = (new Msg(21, [ChildMsg_ofMsg(dragDropChildAbsentStrategy, InOut_wrapInboundMsg(new InboundMsg_1(1, [selected])))])), singleton_1((dispatch_18) => {
                dispatch_18(msg_31);
            }))];
    }
}

